exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".col-auto[data-v-36b1d5df] {\n  padding-left: 0;\n}\n[data-v-36b1d5df] .modal-content {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  top: 10px;\n}\n[data-v-36b1d5df] .modal-header {\n  padding: 5px;\n  padding-left: 12px;\n  height: 33px;\n}\n[data-v-36b1d5df] .modal-footer {\n  padding: 6px;\n}\n", ""]);

